module.exports = __webpack_public_path__ + "img/embedded.5fb400b9.svg";